import React from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { push as Push } from 'redux-first-history';
import { CampaignsPaths, HomePaths } from "@/services/dictionaries/Paths";
import { useLandingPageSubdomain } from "@/components/CheckoutCreator/hooks/useLandingPageSubdomain";
import { LandingPagePaths } from "@/services/dictionaries/Paths";
import { WidgetType, WidgetMap } from "../HomeInterface";
import { SubdomainWidgetContent } from "../components/SubdomainWidgetContent";
import { LinkInBioWidgetContent } from "../components/LinkInBioWidgetContent";
import { CampaignsWidgetContent } from "../components/CampaignsWidgetContent";
import { ContactsGrowthWidgetContent } from "../components/ContactsGrowthWidgetContent";

export const useWidgetConfig = (): WidgetMap => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
     const {accountSubdomain, loading} = useLandingPageSubdomain();    


    const handleConfigureSubdomain = () => {
        window.location.href = HomePaths.EditLPSubdomain;
    };

    const handleViewLinkInBio = () => {
        dispatch(Push(LandingPagePaths.LandingPageList));
    };

    const handleViewCampaigns = () => {
        dispatch(Push(CampaignsPaths.CampaignsTab));
    };

    return {
        [WidgetType.SUBDOMAIN]: {
            title: t('yoursubdomain'),
            content: <SubdomainWidgetContent/>,
            button: {
                textKey: t('edityoursubdomain'),
                onClick: () => handleConfigureSubdomain()
            },
            isButtonVisible: !!accountSubdomain,
            isLoading: loading,
        },
        [WidgetType.LINK_IN_BIO]: {
            title: t('linkinbiopages'),
            content: <LinkInBioWidgetContent/>,
            button: {
                textKey: t('viewlinkinbiopages'),
                onClick: handleViewLinkInBio
            },
            isButtonVisible: true,
            isLoading: false,
        },
        [WidgetType.CAMPAIGNS]: {
            title: t('campaigns'),
            content: <CampaignsWidgetContent/>,
            button: {
                textKey: t('viewcampaignsbtn'),
                onClick: handleViewCampaigns
            },
            isButtonVisible: true,
            isLoading: false,
        },
        [WidgetType.CONTACTS_GROWTH]: {
            title: t('contactsgrowth'),
            content: <ContactsGrowthWidgetContent/>,
            isLoading: false,
            useCustomContentLayout: true,
        }
    };
};
